// src/components/Gallery.js
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { useTranslation } from 'react-i18next';

const imageLinks = [
    '/images/gallery/03-logo-2164653971.png',
    '/images/gallery/1-logo1563458562.png',
    '/images/gallery/1643746791_10.jpg',
    '/images/gallery/1643746823_3.jpg',
    '/images/gallery/1643746824_6.jpg',
    '/images/gallery/1643746876_7.jpg',
    '/images/gallery/17af75e07b553ac5c.jpg',
    '/images/gallery/17af75e100453ac5c.jpg',
    '/images/gallery/17af75e296d53ac5c.jpg',
    '/images/gallery/17af75e2e1353ac5c.jpg',
    '/images/gallery/17af75e4bb353ac5c.jpg',
    '/images/gallery/2-logo1941316148.png',
    '/images/gallery/2cc513cf9b5b4daa9550d0024967f6d0.jpg',
    '/images/gallery/3b08642aa8bf42d3aad223d7206dd172.jpg',
    '/images/gallery/486bd453e3da4d87a71b07954b84d5a0.jpg',
    '/images/gallery/5a1adeb29100496582145573a77771dc.jpg',
    '/images/gallery/660d19f5ad3444df95e56552f188072c.jpg',
    '/images/gallery/76de98852c8d479184f021d01c9f7bd2.jpg',
    '/images/gallery/8da08eb6fc674339ab1286e68c05bba7.jpg',
    '/images/gallery/9805a522ab18841eeb6e8c00adbbc23b.webp',
    '/images/gallery/abcbd31f15f8448ab0d3629307717fee.jpg',
    '/images/gallery/bc6f416d5e5f46809dc411d8a899e8e8.jpg',
    '/images/gallery/be14eb58978243788013358c1d2c36b2.jpg',
    '/images/gallery/c264db7b8f2c4506b31d784325e5b03b.jpg',
    '/images/gallery/c28e286cd8004daeac45850f313b75d7.jpg',
    '/images/gallery/cd59e9bb3d6c425d99cd0c61c2ad5b2a.jpg',
    '/images/gallery/dfc7157843e54c1a9c6a54e4e14557ff.jpg',
    '/images/gallery/efefb2597d9847fc95b50cffac215349.jpg',
    '/images/gallery/fffd1f36493f41089b579ea151bc3435.jpg',
    '/images/gallery/super-people-3.jpg',
    '/images/gallery/wp10421078-super-people-wallpapers.jpg',
    '/images/gallery/wp10421085-super-people-wallpapers.jpg',
    '/images/gallery/wp10421105-super-people-wallpapers.jpg',
    '/images/gallery/wp10421151-super-people-wallpapers.jpg',
    '/images/gallery/wp10421159-super-people-wallpapers.jpg',
];

const Gallery = forwardRef((props, ref) => {
    const gallerySectionRef = useRef(null);
    const { t } = useTranslation();

    const scrollToGallery = () => {
        if (gallerySectionRef.current) {
            gallerySectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useImperativeHandle(ref, () => ({
        scrollToGallery,
    }));

    return (
        <PhotoProvider>
            <div ref={gallerySectionRef} className="content" id="gallery-container">
                <div className="section-title">
                    <span className="title-text">{t('gallery.title')}</span>
                    <span className="arrow-icon">›</span>
                </div>
                <div id="splide-container">
                    <Splide
                        options={{
                            type: 'loop',
                            gap: '1rem',
                            autoplay: true,
                            interval: 5000,
                            width: '100%',
                            perPage: 4,
                            perMove: 1,
                            breakpoints: {
                                1200: { perPage: 3 },
                                768: { perPage: 2 },
                                480: { perPage: 1 },
                            },
                            arrows: true,
                            pagination: false,
                        }}
                    >
                        {imageLinks.map((link, index) => (
                            <SplideSlide key={index}>
                                <PhotoView
                                    src={link}
                                    drag={false}
                                >
                                    <img
                                        src={link}
                                        alt={`Gallery ${index + 1}`}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                        }}
                                    />
                                </PhotoView>
                            </SplideSlide>
                        ))}
                    </Splide>
                </div>
            </div>
        </PhotoProvider>
    );
});

export default Gallery;
